import { useTranslation } from 'react-i18next';
import CollapsibleWrapper, { Panel } from '../../../../../components/wrappers/CollapsibleWrapper';
import ExportExcel from '../../shared/ExportExcel';
import ImportExcel from '../../shared/ImportExcel';
import DisplacementValueTable, { useDisplacementExcelHandler } from './DisplacementValueTable';

const mappedHeaders = {
    'Engine Displacement Min.*': 'min',
    'Engine Displacement Max.*': 'max',
    'Tax*': 'value',
};

export type LicenseTaxTabProps = {
    disabled?: boolean;
};

const settingsKey = 'licenseAndFuelTax.licenseTable';

const LicenseTaxTable = ({ disabled = false }: LicenseTaxTabProps) => {
    const { t } = useTranslation(['financeProductDetails']);
    const { onImport, onExport } = useDisplacementExcelHandler(
        settingsKey,
        mappedHeaders,
        t('financeProductDetails:tables.ucclLeasing.licenseTax')
    );

    // Initial values has been set it "FinanceProductInitializer"
    // With it's the default values
    // So left with rendering

    return (
        <CollapsibleWrapper defaultActiveKey={['licenseTax']}>
            <Panel key="licenseTax" header={t('financeProductDetails:tables.ucclLeasing.licenseTax')}>
                <DisplacementValueTable
                    disabled={disabled}
                    labelKey={t('financeProductDetails:tables.ucclLeasing.columnTitles.engineDisplacement')}
                    settingsKey={settingsKey}
                    valueKey={t('financeProductDetails:tables.ucclLeasing.columnTitles.licenseTaxValue')}
                />
            </Panel>
            <ImportExcel
                mappedHeaders={mappedHeaders}
                onImport={onImport}
                title={t('financeProductDetails:importModal.titles.ucclLeasing.licenseTax')}
            />
            <ExportExcel onClick={onExport} />
        </CollapsibleWrapper>
    );
};

export default LicenseTaxTable;
